import React from 'react';
import {Link} from 'react-router-dom'
import {
  Container,
  Row,
  Col
} from 'reactstrap'
import Layout from '../../Layout/Layout';
import PageHeader from '../../PageHeader/PageHeader';

const PortalHomeScreen = () => {
  return (
    <Layout product="portal">
      <PageHeader title='Connect Home' />
      <Container fluid>
        <Row>
          <Col>
          <br/>
          <h1>More features coming...</h1>
          <div/>
          <h4>
            We are working to provide more features to improve your experience and
            will be announcing these in the future. Please see below sequence
            to set up your profile.
          </h4>
          </Col>
        </Row>
        <br/>
        <br/>
        <Row>
          <Col>
            <Link to='/content' style={{textDecoration: 'underline'}}>
              <h4>
                Step One: Compose Content
              </h4>
            </Link>
            <div>
              <h5>
                This section can be used to describe your company in depth. Upload videos
                and images to better explain your business. Use the "Sample" button for more
                guidance on the content on this section.
              </h5>
            </div>
          </Col>
          <Col>
            <Link to='/portal-upload' style={{textDecoration: 'underline'}}>
              <h4>
                Step Two: Upload Files
              </h4>
            </Link>
            <div>
              <h5>
                Upload important files about your company to our secure data vault.
                Documents like financial forecasts and pitch decks are recommended.
              </h5>
            </div>
          </Col>
        </Row>
        <Row><Col><br/><br/></Col></Row>
        <Row>
          <Col>
            <Link to='/criteria' style={{textDecoration: 'underline'}}>
              <h4>
                Step Three: Specify Criteria
              </h4>
            </Link>
            <div>
              <h5>
                Investors will find your company based on the criteria in this page.
                Specify your company industry, keywords, funding round,
                regulation type or more.
              </h5>
            </div>
          </Col>
          <Col>
            <Link to='/search-sof' style={{textDecoration: 'underline'}}>
              <h4>
                Step Four: Search for Sources of Funds
              </h4>
            </Link>
            <div>
              <h5>
                Use filters to find sources of funds based on the types of
                companies they are looking to invest in. When you've found the
                right fit, click and send messages to set up further meetings.
              </h5>
            </div>
           </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export default PortalHomeScreen;
